<template>
  <div @dragenter="onDragEnter" @dragleave="active = false" @dragover.prevent @drop.prevent="onDrop">
    <slot :active="active"></slot>
  </div>
</template>

<script>
export default {
  props: {
    accept: String,
    disabled: Boolean,
  },
  data: () => ({
    active: false,
  }),
  methods: {
    onDragEnter(event) {
      const types = event.dataTransfer?.types ?? [];
      this.active = types.includes('Files');
    },
    onDrop(event) {
      const [file] = event?.dataTransfer?.files ?? [];

      if (this.accept.includes(file?.type)) {
        this.$emit('drop', file);
      }
      this.active = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
